import { z } from 'zod';
import { datetime } from './commons';
export const ContributionsStatus = {
    pending: 'PENDING',
    asked: 'ASKED',
    inprogress: 'INPROGRESS',
    waitingForCertificate: 'WAITING_FOR_CERTIFICATE',
    answered: 'ANSWERED',
    supported: 'SUPPORTED',
};
export const ContributionsStatusEnum = z.nativeEnum(ContributionsStatus);
export const ContributionsTypes = {
    avis: 'AVIS',
    modification: 'MODIFICATION',
    avisFinancement: 'AVIS_FINANCEMENT',
    redirection: 'REDIRECTION',
};
export const ContributionsTypesEnum = z.nativeEnum(ContributionsTypes);
export const ContributionSchema = z.object({
    active: z.boolean(),
    avis: z.object({}).optional(),
    date: datetime,
    dateEnvoi: z.string(),
    demande: z.object({
        href: z.string(),
    }),
    history: z.object({}).optional(),
    id: z.string(),
    kind: z.literal('contribution'),
    reference: z.string(),
    statut: ContributionsStatusEnum,
    tenant: z.string(),
    tiers: z.object({
        href: z.string(),
    }),
    title: z.string(),
    typeContribution: ContributionsTypesEnum,
});
export const ContributionsResponseSchema = z.object({
    _embedded: z.object({
        items: z.array(ContributionSchema),
    }),
    _links: z.object({}),
    count: z.number(),
    title: z.literal('contribution'),
    total: z.number(),
});
//# sourceMappingURL=contributions.js.map